export const enum AddressRequirement {
    None = 0,
    Location = 2,
    ZipCode = 1,
}

export enum LocationSearchMode {
    "NONE",
    "ZIP",
    "HOSPITAL",
}
